<template>
    <div>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    export default {
        name: "LogOff",
        components: {
        },
        data() {
            return {
            };
        },
        methods: {
            ...mapActions("oidcStore", [
                "signOutOidc"
            ]),
        },
        mounted() {
            this.signOutOidc();
        },
    };
</script>
<style scoped>
</style>

